<template lang="pug">
DatePicker(
  v-model="date"
  showIcon
  fluid
  :name="name"
  :showButtonBar="$attrs.showButtonBar"
  :manualInput="$attrs.manualInput"
  :class="$attrs.class"
  :id="$attrs.id"
  :disabled="$attrs.disabled ?? false"
  :dateFormat="$attrs.dateFormat"
  :size="$attrs.size"
  :placeholder="$attrs.placeholder"
)
</template>

<script setup>
import { computed, defineOptions } from 'vue'
import DatePicker from "primevue/datepicker"

defineOptions({
  inheritAttrs: false
});

const { name } = defineProps({
  name: { type: String, default: null },
})

const model = defineModel()

const date = computed({
  get: () => {
    if (model.value && dayjs(model.value).isValid()) {
      return dayjs(model.value).toDate()  
    } else {
      return null;
    }
  },
  set: (value) => {
    if (dayjs(value).isValid()) {
      model.value = dayjs(value).format()
    } else {
      model.value = null
    }
  }
})
</script>